import { BaseDialogResult, bindDialog, BindDialogReturn, DialogProps, DialogState, useDialogState } from "../../hooks/use-dialog-state/UseDialogState";
import { useTranslation } from "react-i18next";
import { ApplicationMimeTypesEnum } from "../../common/enums/ApplicationMimeTypesEnum";
import ResponsiveDialog from "../responsive-dialog/ResponsiveDialog";
import { PhotoViewer } from "./viewers/PhotoViewer";
import { UnsupportedViewer } from "./viewers/UnsupportedViewer";

export type FileViewerDialogInitValues = {
    title?: string;
    url?: string;
    mimeType?: ApplicationMimeTypesEnum;
};

export type FileViewerDialogResultReasons = "close";

export type FileViewerDialogResult = BaseDialogResult<FileViewerDialogResultReasons>;

export type FileViewerDialogProps = DialogProps<FileViewerDialogInitValues, FileViewerDialogResult>;

export default function FileViewerDialog({
    open,
    onClose,
    values
}: FileViewerDialogProps) {
    const { t } = useTranslation();

    function getViewer() {
        switch (values?.mimeType) {
            case ApplicationMimeTypesEnum.JPEG:
            case ApplicationMimeTypesEnum.PNG:
            case ApplicationMimeTypesEnum.GIF:
            case ApplicationMimeTypesEnum.SVG:
                return PhotoViewer;
            default:
                return UnsupportedViewer;
        }
    }

    const Viewer = getViewer();

    return (
        <ResponsiveDialog
            title={values?.title as string}
            hideOkay={true}
            enableOkay={false}
            okayLabel={undefined}
            cancelLabel={t("buttons.close")}
            open={open}
            onClose={() => {
                onClose({ reason: "close" });
            }}
        >
            <Viewer {...values} />
        </ResponsiveDialog>
    );
}

export type FileViewerDialogState = DialogState<FileViewerDialogInitValues, FileViewerDialogResult>;
export type BindFileViewerDialogReturn = BindDialogReturn<FileViewerDialogInitValues, FileViewerDialogResult>;

export function useFileViewerDialogState(): FileViewerDialogState {
    return useDialogState();
}

export function bindFileViewerDialog(props: FileViewerDialogState): BindFileViewerDialogReturn {
    return bindDialog(props);
}
